<template>
  <div class="integration-page-wrapper">
    <div v-if="item !== null && loaded" class="integration-page">
      <iframe
        ref="iframe"
        :src="currentIntegration.url"
        frameborder="0"
        width="100%"
        height="100%"
      ></iframe>

      <v-container
        v-if="currentIntegration && currentIntegration.is_finished"
        class="container-fixed"
      >
        <v-row justify="center">
          <v-col sm="4" md="4" lg="4">
            <div class="integration_page--end">
              <div class="icon-complete">
                <img src="/static/images/elements/icon_ok.svg" />
              </div>

              <div class="testend-title">
                {{ $tr('interview.tests.end.title') }}<br />
                {{ $tr('videoInterview.end.thanksWithoutName') }}
              </div>

              <div class="description">{{ $tr('interview.tests.end.answersSend') }}</div>

              <div class="btns">
                <div v-if="is_record" class="btns__button btns__button_to-stage" @click="nextStage">
                  {{ $tr('interview.tests.endTime.next') }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <vpreloader v-if="!loaded" width="2" size="64" />
    </div>
    <vfooter type="landing" :company_language="company_language" />
  </div>
</template>

<script>
  import vfooter from '@/routes_new/outer/components/vfooter.vue';
  import { mapActions, mapState, mapMutations } from 'vuex';

  export default {
    name: 'InterviewIntegration',

    components: {
      vfooter
    },

    data() {
      return {
        loaded: false,
        currentIntegration: null
      };
    },

    computed: {
      ...mapState('integrations', ['item', 'token', 'isIntegrationStarted']),

      company_language() {
        return this.$store.getters['interview/company_language'];
      },

      interview() {
        return this.$store.getters['interview/one'];
      },

      is_record() {
        if (this.interview && this.interview.active_modules) {
          return this.interview.active_modules.find(el => el.id === 'videointerview');
        } else {
          return false;
        }
      }
    },

    async created() {
      await this.SET_TOKEN(this.$route.params.token);

      if (this.token) {
        await this.fetch({ token: this.token });
      }
    },

    async mounted() {
      await this.integrationInit();

      const iframe = this.$refs.iframe;
      let that = this;

      iframe.onload = function () {
        that.loaded = true;
      };
    },

    methods: {
      ...mapMutations('integrations', ['SET_TOKEN', 'SET_ITEM']),
      ...mapActions('integrations', [
        'integrationLoad',
        'integrationStart',
        'integrationEnd',
        'integrationStartLink',
        'integrationEndLink'
      ]),

      ...mapActions('interview', ['fetch']),

      async integrationInit() {
        await this.SET_TOKEN(this.$route.params.token);
        await this.integrationLoad();

        if (!this.isIntegrationStarted) {
          await this.integrationStart();
        }

        if (this.item !== null) {
          // Фильтруем все непройденные ссылки по интеграциям
          const notPassedIntegrations = this.item.links.filter(x => !x.is_finished);

          if (notPassedIntegrations.length > 0) {
            // Если непройденные есть, то стартуем интеграцию по конкретной ссылке
            this.loaded = false;
            this.currentIntegration = notPassedIntegrations[0];
            await this.integrationStartLink(this.currentIntegration.id).finally(() => {
              this.loaded = true;
            });
          } else {
            // Если непройденныех нет, то завершаем интеграционный модуль
            this.currentIntegration = null;
            await this.integrationEnd();
            this.$router.push({ name: 'interview', params: { token: this.token } });
          }
        }

        // Если приходит событие о завершении интеграции
        window.addEventListener('message', event => {
          this.onMessage(event);
        });
      },

      async onMessage(event) {
        if (event && event.data && event.data.sender === 'vcv_integration') {
          if (this.currentIntegration !== null) {
            await this.integrationEndLink(this.currentIntegration.id);
            await this.integrationInit();
          } else {
            await this.integrationEnd();
            this.$router.push({ name: 'interview', params: { token: this.token } });
          }
        }

        window.removeEventListener('message', event => {
          this.onMessage(event);
        });
      },

      nextStage() {
        this.$store.commit('interview/videointerview/next_stage');
        this.$router.push({ path: `/record/${this.token}` });
      }
    }
  };
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';

::v-deep {
  .preloader-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #e5e5e5;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.justify-center {
  justify-content: center;
}
.integration-page {
  -webkit-user-select: none;
  user-select: none;
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 60px);
  background-color: #e5e5e5;
  overflow: hidden;
  justify-content: center;
  position: relative;

  iframe {
    position: absolute;
    top: 0;
  }

  &-wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
  }
}
.integration_page--end {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  background: #f4f5f7;
  padding: 3rem;
  color: #233346;

  .icon-complete {
    width: 56px;
    height: 56px;
    margin: 0 auto 20px;
  }

  .testend-title {
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    margin: 0 auto 20px;
  }

  .description {
    font-size: 15px;
    line-height: 24px;
    margin: 0 auto;
  }

  .btns {
    display: flex;

    &__button {
      display: block;
      padding: 9px 20px;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      cursor: pointer;
      margin: 10px auto 20px;
      border-radius: 2px;

      &_to-stage {
        background: $green;
        color: #ffffff;
      }

      &_to-vacancy {
        background: #f4f5f7;
        color: $green;
        margin-left: 20px;
      }
    }
  }
}
</style>
